import { Box, ButtonBase } from "@mui/material";
import { Colors } from "Components/Layout/Themes/Colors";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Balance.BalanceContent;

type Props = {
  currencies: ReadonlyArray<string>;
  selectedCurrency: string;
  onSelect: (currency: string) => void;
};

/** Segmented "CZK | EUR" switcher for the desktop balance card: the selected code sits on a raised white chip. */
export const CurrencyToggle = ({
  currencies,
  selectedCurrency,
  onSelect,
}: Props) => {
  const { t } = useResource();

  return (
    <Box
      role="group"
      aria-label={t(RESOURCES.CurrencySheetTitle)}
      display="inline-flex"
      p={1}
      borderRadius={2}
      bgcolor={Colors.LightGray}
    >
      {currencies.map((currency) => {
        const isSelected = currency === selectedCurrency;

        return (
          <ButtonBase
            key={currency}
            onClick={() => onSelect(currency)}
            aria-pressed={isSelected}
            sx={{
              px: 3,
              py: 1,
              borderRadius: 1.5,
              fontWeight: 600,
              fontSize: 12,
              lineHeight: "16px",
              transition: "background-color 0.15s ease, color 0.15s ease",
              ...(isSelected
                ? {
                    bgcolor: "common.white",
                    color: "primary.main",
                    // Soft, low lift — a flat MUI elevation reads too sharp at this size.
                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.08)",
                  }
                : {
                    color: "text.secondary",
                  }),
            }}
          >
            {currency}
          </ButtonBase>
        );
      })}
    </Box>
  );
};
